export const helpLinkIds = {
  // AbsoluteTopImpressionRatePercent
  AbsoluteTopImpressionRatePercent: 'pop_BA_Reporting_Clarity_AbsoluteTopImpressionRate',
  // AbsoluteTopImpressionShareLostToBudgetPercent
  AbsoluteTopImpressionShareLostToBudgetPercent: 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoBudget',
  // AbsoluteTopImpressionShareLostToRankPercent
  AbsoluteTopImpressionShareLostToRankPercent: 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoRank',
  // AbsoluteTopImpressionSharePercent
  AbsoluteTopImpressionSharePercent: 'pop_BA_Reporting_ProductAds_AbsoluteTopImpShare',
  // AccountId
  AccountId: 'pop_BA_Reporting_Clarity_AccountID',
  // AccountName
  AccountName: 'pop_BA_Reporting_Clarity_Account',
  // AccountNumber
  AccountNumber: 'pop_BA_Reporting_Clarity_AccountNumber',
  // AccountStatus
  AccountStatus: 'pop_BA_Reporting_Clarity_AccountStatus',
  // AdDescription
  AdDescription: 'pop_BA_Reporting_Clarity_AdDescription',
  // AdDescription2
  AdDescription2: 'pop_BA_Reporting_Clarity_AdDescription2',
  // AdDistribution
  AdDistribution: 'pop_BA_NewCampaignCreate_Distribute',
  // AdExtensionId
  AdExtensionId: 'pop_BA_Reporting_Clarity_AdExtID',
  // AdExtensionPropertyValue
  AdExtensionPropertyValue: 'Page_Reporting_Clarity_AdExtensionDisplayName',
  // AdExtensionType
  AdExtensionType: 'Page_Reporting_Clarity_AdExtensionTypeName',
  // AdExtensionTypeId
  AdExtensionTypeId: 'pop_BA_Reporting_Clarity_AdExtensionTypeID',
  // AdExtensionVersion
  AdExtensionVersion: 'pop_BA_Reporting_Clarity_AdExtVersion',
  // AdvertiserHotelId
  AdvertiserHotelId: 'pop_BA_Reporting_Clarity_AdvertiserHotelId',
  // AdGroupCriterionId
  AdGroupCriterionId: 'pop_BA_Reporting_Clarity_ProdTargetID',
  // AdGroupId
  AdGroupId: 'pop_BA_Reporting_Clarity_AdGroupID',
  // AdGroupLabels
  AdGroupLabels: 'pop_BA_Reporting_Clarity_AdGroupLabels',
  // AdGroupName
  AdGroupName: 'pop_BA_Reporting_Clarity_AdGroup',
  // AdGroupStatus
  AdGroupStatus: 'pop_BA_Reporting_Clarity_AdGroupStatus',
  // AdGroupType
  AdGroupType: 'pop_BA_DSA_AdGroupType',
  AdGroupTypePreview: 'pop_BA_DSA_AdGroupType',
  // AdId
  AdId: 'pop_BA_CampaignGrids_AdID',
  // AdLabels
  AdLabels: 'pop_BA_Reporting_Clarity_AdLabels',
  // AdRelevance
  AdRelevance: 'pop_BA_Reporting_Clarity_AdRelevance',
  // AdScenarioType
  AdScenarioType: 'pop_BA_Reporting_Clarity_VerticalAdType',
  // AdStatus
  AdStatus: 'pop_BA_Reporting_Clarity_AdStatus',
  // AdStrength
  AdStrength: 'pop_BA_Reporting_AdStrength',
  // AdStrengthActionItems
  AdStrengthActionItems: 'pop_BA_Reporting_AdStrengthSuggestions',
  // AdTitle
  AdTitle: 'pop_BA_Reporting_Clarity_AdTitle',
  // AdType
  AdType: 'pop_BA_CampaignGrids_AdType',
  // AgeGroup
  AgeGroup: 'pop_BA_Reporting_Clarity_AgeGroup',
  // AgencyName
  AgencyName: 'pop_BA_Reporting_Clarity_Agency',
  // AllConversionRate
  AllConversionRate: 'pop_BA_CampaignGrids_AllConvRate',
  AllConversionRateQualified: 'pop_BA_CampaignGrids_AllConvRate',
  // AllConversions
  AllConversions: 'pop_BA_CampaignGrids_AllConv',
  AllConversionsQualified: 'pop_BA_CampaignGrids_AllConv',
  // AllCostPerConversion
  AllCostPerConversion: 'pop_BA_CampaignGrids_AllConvCPA',
  AllCostPerConversionQualified: 'pop_BA_CampaignGrids_AllConvCPA',
  // AllReturnOnAdSpend
  AllReturnOnAdSpend: 'pop_BA_CampaignGrids_AllConvROAS',
  // AllRevenue
  AllRevenue: 'pop_BA_CampaignGrids_AllConvRevenue',
  // AllRevenuePerConversion
  AllRevenuePerConversion: 'pop_BA_Reporting_Clarity_AllRevenueConversion',
  // AreaCode
  AreaCode: 'pop_BA_Reporting_Clarity_AreaCode',
  // AssistedClicks
  AssistedClicks: 'pop_BA_Reporting_CoopClicks',
  // AssistedConversions
  AssistedConversions: 'pop_BA_Reporting_CoopConv',
  // AssistedImpressions
  AssistedImpressions: 'pop_BA_Reporting_CoopImpr',
  // Assists
  Assists: 'Page_Reporting_Clarity_Assists',
  // AssociationId
  AssociationId: 'pop_BA_Reporting_Clarity_AssociationID',
  // AssociationLevel
  AssociationLevel: 'pop_BA_Reporting_Clarity_Level',
  // AssociationStatus
  AssociationStatus: 'pop_BA_AudienceStatus',
  // AttributeChanged
  AttributeChanged: 'pop_BA_Reporting_Clarity_AttributeChange',
  // AudienceId
  AudienceId: 'pop_BA_Reporting_Clarity_AudienceID',
  AudienceImpressionSharePercent: 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare',
  AudienceImpressionLostToRankPercent: 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare_LostRank',
  AudienceImpressionLostToBudgetPercent: 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare_LostBudget',
  // AudienceName
  AudienceName: 'pop_BA_Reporting_Clarity_AudienceName',
  // AudienceType
  AudienceType: 'pop_BA_AudienceCategory',
  // AverageCPC
  AverageCPC: 'pop_BA_CampaignGrids_AvgCPC',
  // AverageCPM
  AverageCPM: 'Page_Reporting_Clarity_AverageCPM',
  // AverageCpp
  AverageCpp: 'pop_BA_CampaignGrids_AvgCPP',
  // Average impression frequency
  AverageImpressionFrequencyPerUser: 'pop_BA_Avg_Impr_Freq',
  AverageImpressionFrequencyPerUser7Day: 'pop_BA_Avg_Impr_Freq_Days',
  // AveragePosition
  AveragePosition: 'pop_BA_CampaignGrids_AvgPosition',
  // AvgBookedABW
  AvgBookedABW: 'pop_BA_Reporting_Clarity_AvgBookedABW',
  // AvgBookedNights
  AvgBookedNights: 'pop_BA_Reporting_Clarity_AvgBookedNights',
  BaseCampaignId: 'Pop_BA_Reporting_Clarity_BaseCampaignID',
  // BenchmarkBid
  BenchmarkBid: 'pop_BA_Reporting_Clarity_BenchmarkBid',
  // BenchmarkCtr
  BenchmarkCtr: 'pop_BA_Reporting_Clarity_BenchmarkCTR',
  // BidAdjustment
  BidAdjustment: 'pop_BA_AudienceBidAdj',
  // BidMatchType
  BidMatchType: 'Page_Reporting_Clarity_BidMatchType',
  // BidStrategyType
  BidStrategyType: 'pop_BA_Reporting_Clarity_BidStrategy',
  // BilledAmount
  BilledAmount: 'pop_BA_Reporting_Clarity_BillAmount',
  BilledAmountUSD: 'pop_BA_Reporting_Clarity_BillAmountUSD',
  // BillingType
  BillingType: 'pop_BA_Reporting_Clarity_BillingType',
  // BillToCustomerName
  BillToCustomerName: 'pop_BA_Reporting_Clarity_BillToName',
  // BillToCustomerNumber
  BillToCustomerNumber: 'pop_BA_AccountsGrid_BillTo',
  // BillToCountry
  BillToCountry: 'pop_BA_Reporting_Clarity_BillToCountry',
  // BookedABW
  BookedABW: 'pop_BA_Reporting_Clarity_BookedABW',
  // BookedLengthOfStay
  BookedLengthOfStay: 'pop_BA_Reporting_Clarity_BookedLengthOfStay',
  // Brand
  Brand: 'pop_BA_Reporting_Clarity_Brand',
  // BudgetAssociationStatus
  BudgetAssociationStatus: 'pop_BA_Reporting_Clarity_BudgetAssociation',
  // BudgetName
  BudgetName: 'pop_BA_Reporting_Clarity_Budget',
  // BudgetStatus
  BudgetStatus: 'pop_BA_Reporting_Clarity_BudgetStatus',
  // BusinessName
  BusinessName: 'pop_BA_Reporting_Clarity_BusinessName',
  // CPA
  CPA: 'Page_Reporting_Clarity_CPA',
  // CTR
  CTR: 'pop_BA_CampaignGrids_CTR',
  // CampaignHotelId
  CampaignHotelId: 'pop_BA_Reporting_Clarity_CampaignHotelId',
  // CampaignId
  CampaignId: 'pop_BA_Reporting_Clarity_CampaignID',
  // CampaignLabels
  CampaignLabels: 'pop_BA_Reporting_Clarity_CampaignLabels',
  // CampaignName
  CampaignName: 'pop_BA_Reporting_Clarity_Campaign',
  // CampaignStatus
  CampaignStatus: 'pop_BA_Reporting_Clarity_CampaignStatus',
  // CampaignType
  CampaignType: 'pop_BA_Reporting_Clarity_CampaignType',
  // Category
  Category: 'pop_BA_Reporting_Clarity_Category',
  // Category0
  Category0: 'pop_BA_Reporting_Clarity_DSA_TopLevelCategory',
  // Category1
  Category1: 'pop_BA_Reporting_Clarity_DSA_FirstLevelCategory',
  // Category2
  Category2: 'pop_BA_Reporting_Clarity_DSA_SecondLevelCategory',
  // CategoryList
  CategoryList: 'pop_BA_Reporting_Clarity_DSA_CategoryList',
  // ChangeMadeBy
  ChangeMadeBy: 'pop_BA_Reporting_Clarity_ChangedBy',
  // ChangeMadeTo
  ChangeMadeTo: 'pop_BA_Reporting_Clarity_User',
  ChangeTotalCount: null,
  // ChangedBy
  ChangedBy: 'pop_BA_Reporting_Clarity_ChangedBy',
  // CheckInDate
  CheckInDate: 'pop_BA_Reporting_Clarity_CheckInDate',
  // City
  City: 'pop_BA_Reporting_Clarity_CityLocation',
  // ClickCalls
  ClickCalls: 'pop_BA_CampaignGrids_ClickCalls',
  // ClickSharePercent
  ClickSharePercent: 'pop_BA_Reporting_Clarity_ClickShare',
  // ClickType
  ClickType: 'pop_BA_Reporting_Clarity_ClickType',
  // ClickTypeId
  ClickTypeId: 'pop_BA_Reporting_product_ads_click_type',
  // Clicks
  Clicks: 'pop_BA_CampaignGrids_Clicks',
  // CombinationLongHeadline
  CombinationLongHeadline: 'pop_BA_Reporting_Clarity_LongHeadline',
  // CompanyName
  CompanyName: 'pop_BA_Reporting_Clarity_CompanyName',
  // Condition
  Condition: 'pop_BA_Reporting_Clarity_Condition',
  // ConflictLevel
  ConflictLevel: 'pop_BA_Reporting_Clarity_ConflictLevel',
  // ConflictType
  ConflictType: 'pop_BA_Reporting_Clarity_ConflictType',
  // ConversionRate
  ConversionRate: 'pop_BA_CampaignGrids_ConvRate',
  ConversionRateQualified: 'pop_BA_CampaignGrids_ConvRate',
  // Conversions
  Conversions: 'pop_BA_CampaignGrids_Conv',
  ConversionsQualified: 'pop_BA_CampaignGrids_Conv',
  // CostPerAssist
  CostPerAssist: 'pop_BA_Reporting_Clarity_CostPerAssist',
  // CostPerConversion
  CostPerConversion: 'Page_Reporting_Clarity_CPA',
  CostPerConversionQualified: 'Page_Reporting_Clarity_CPA',
  // Country
  Country: 'pop_BA_Reporting_Clarity_CountryRegion',
  // Feed Label
  FeedLabel: 'pop_BA_BMC_FeedLabel',
  // CountryOfSale
  CountryOfSale: 'pop_BA_Reporting_Clarity_ProductCountryofSale',
  // CountryName
  CountryName: 'pop_BA_Reporting_Clarity_CountryName',
  // County
  County: 'pop_BA_Reporting_Clarity_CountyLocation',
  // CurrencyCode
  CurrencyCode: 'Page_Accounts_Details_Currency',
  // CurrentMaxCpc
  CurrentMaxCpc: 'pop_BA_Reporting_Clarity_MaxCPC',
  // CustomLabel0
  CustomLabel0: 'pop_BA_Reporting_Clarity_CustomLabel',
  // CustomLabel1
  CustomLabel1: 'pop_BA_Reporting_Clarity_CustomLabel',
  // CustomLabel2
  CustomLabel2: 'pop_BA_Reporting_Clarity_CustomLabel',
  // CustomLabel3
  CustomLabel3: 'pop_BA_Reporting_Clarity_CustomLabel',
  // CustomLabel4
  CustomLabel4: 'pop_BA_Reporting_Clarity_CustomLabel',
  // CustomParameters
  CustomParameters: 'pop_BA_Reporting_Clarity_CustomParameters',
  // CustomerId
  CustomerId: 'pop_BA_Reporting_Clarity_Customer',
  // CustomerName
  CustomerName: 'pop_BA_Reporting_Clarity_CustomerName',
  // DailySpend
  DailySpend: 'pop_BA_Reporting_Clarity_SpendDaily',
  // Date
  Date: 'pop_BA_Reporting_Clarity_Date',
  // DateTime
  DateTime: 'pop_BA_Reporting_Clarity_Date',
  // DateType
  DateType: 'pop_BA_Reporting_Clarity_DateType',
  // DayOfWeek
  DayOfWeek: 'pop_BA_Reporting_Clarity_DayOfWeek',
  // DeliveredMatchType
  DeliveredMatchType: 'Page_Reporting_Clarity_DeliveredMatchType',
  // Description1
  Description1: 'pop_BA_RSA_Combo_Description',
  // Description2
  Description2: 'pop_BA_RSA_Combo_Description',
  // DestinationUrl
  DestinationUrl: 'pop_BA_CampaignGrids_DestinationURL',
  // DeviceOS
  DeviceOS: 'pop_BA_Reporting_Clarity_DeviceOS',
  // DeviceType
  DeviceType: 'pop_BA_Reporting_Clarity_DeviceType',
  // DisplayUrl
  DisplayUrl: 'pop_BA_Reporting_Clarity_DisplayURL',
  // DocumentNumber
  DocumentNumber: 'pop_BA_Reporting_Clarity_DocumentNum',
  // DocumentType
  DocumentType: 'pop_BA_Reporting_Clarity_DocumentType',
  // Duration
  Duration: 'pop_BA_Reporting_Clarity_Duration',
  // DynamicAdTarget
  DynamicAdTarget: 'pop_BA_Reporting_Clarity_DSA_AutoTarget',
  // DynamicAdTargetId
  DynamicAdTargetId: 'pop_BA_Reporting_Clarity_DSA_AutoTargetId',
  // DynamicAdTargetStatus
  DynamicAdTargetStatus: 'pop_BA_Reporting_Clarity_DSA_AutoTargetStatus',
  // EligibleImpressions
  EligibleImpressions: 'pop_BA_Reporting_Clarity_EligibleImpressions',
  // ExcludeZeroClicks
  ExcludeZeroClicks: null,
  // EndTime
  EndTime: 'pop_BA_Reporting_Clarity_CallEndTime',
  // EntityId
  EntityId: 'pop_BA_Reporting_Clarity_EntityID',
  // EntityName
  EntityName: 'pop_BA_Reporting_Clarity_EntityName',
  // ExactMatchImpressionSharePercent
  ExactMatchImpressionSharePercent: 'Page_Reporting_Clarity_ExactMatchImpressionShare',
  // ExpectedCtr
  ExpectedCtr: 'Page_Reporting_Clarity_KeywordRelevance',
  // ExtendedCost
  ExtendedCost: 'pop_BA_Reporting_Clarity_ExtendedCost',
  // FeedUrl
  FeedUrl: 'pop_BA_Reporting_Clarity_DSA_FeedURL',
  // FinalAppUrl
  FinalAppUrl: 'pop_BA_Reporting_Clarity_FinalAppURL',
  // FinalMobileUrl
  FinalMobileUrl: 'pop_BA_Reporting_Clarity_FinalMobileURL',
  // FinalUrl
  FinalUrl: 'pop_BA_Reporting_Clarity_FinalURL',
  // FinalUrlSuffix
  FinalUrlSuffix: 'pop_BA_NewAdCreate_FinalURLSuffix',
  // FirstPageBid
  FirstPageBid: 'pop_BA_CampaignGrids_FirstPage',
  // FullViewConversions
  FullViewConversions: 'pop_BA_Reporting_Clarity_ViewThrough',
  // Gender
  Gender: 'pop_BA_Reporting_Clarity_Gender',
  // Goal
  Goal: 'pop_BA_Reporting_Clarity_Goal',
  // GoalCategory
  GoalCategory: 'pop_BA_Reporting_Clarity_GoalCategory',
  // GoalId
  GoalId: 'pop_BA_Reporting_Clarity_GoalID',
  // GoalType
  GoalType: 'pop_BA_Reporting_Clarity_GoalType',
  // GregorianDate
  GregorianDate: 'pop_BA_Reporting_Clarity_Date',
  // GrossReturnOnAdSpend
  GrossReturnOnAdSpend: 'pop_BA_Reporting_Clarity_GrossReturnOnAdSpend',
  GTIN: 'pop_BA_DimensionGrid_GTIN',
  // Headline
  Headline: 'pop_BA_Reporting_Clarity_DSA_Headline',
  // Headline1
  Headline1: 'pop_BA_RSA_Combo_Headline',
  // Headline2
  Headline2: 'pop_BA_RSA_Combo_Headline',
  // Headline3
  Headline3: 'pop_BA_RSA_Combo_Headline',
  // Description
  Description: 'pop_BA_Reporting_Clarity_DSA_Description',
  // HistoricalAdRelevance
  HistoricalAdRelevance: 'pop_BA_Reporting_Clarity_HistoricAdRelevance',
  // HistoricalExpectedCtr
  HistoricalExpectedCtr: 'pop_BA_Reporting_Clarity_HistoricCTR',
  // HistoricalLandingPageExperience
  HistoricalLandingPageExperience: 'pop_BA_Reporting_Clarity_HistoricLandingPage',
  // HistoricalQualityScore
  HistoricalQualityScore: 'pop_BA_Reporting_Clarity_HistoricQS',
  // HotelGroup
  HotelGroup: 'pop_BA_Reporting_Clarity_HotelGroup',
  // HotelGroupNodeId
  HotelGroupNodeId: 'pop_BA_Reporting_Clarity_HotelGroupNodeId',
  // HotelName
  HotelName: 'pop_BA_Reporting_Clarity_HotelName',
  // HourOfDay
  HourOfDay: 'pop_BA_Reporting_Clarity_HourOfDay',
  // HowChanged
  HowChanged: 'pop_BA_Reporting_Clarity_HowChanged',
  // Image
  Image: 'pop_BA_Reporting_Combination_Image',
  // ImpressionLostToAdRelevancePercent
  ImpressionLostToAdRelevancePercent: 'pop_BA_Reporting_Clarity_ImpShrLostRev',
  // ImpressionLostToBidPercent
  ImpressionLostToBidPercent: 'pop_BA_Reporting_Clarity_ImpShrLostBid',
  // ImpressionLostToBudgetPercent
  ImpressionLostToBudgetPercent: 'pop_BA_Reporting_Clarity_ImpShrLostBudget',
  // ImpressionLostToExpectedCtrPercent
  ImpressionLostToExpectedCtrPercent: 'pop_BA_Reporting_Clarity_ImpShrLostClickThru',
  // ImpressionLostToRankAggPercent
  ImpressionLostToRankAggPercent: 'pop_BA_Reporting_Clarity_ImpShrLostRank',
  // ImpressionLostToRankPercent
  ImpressionLostToRankPercent: 'pop_BA_Reporting_Clarity_ImpShrLostRank',
  // ImpressionShare
  ImpressionShare: 'pop_BA_Reporting_Clarity_ImpressionShare',
  // ImpressionSharePercent
  ImpressionSharePercent: 'Page_Reporting_Clarity_ImpressionShare',
  // Impressions
  Impressions: 'pop_BA_CampaignGrids_Impr',
  // IndustryName
  IndustryName: 'pop_BA_Reporting_Clarity_IndustryName',
  // ItemChanged
  ItemChanged: 'pop_BA_Reporting_Clarity_EntityType',
  // JobFunctionName
  JobFunctionName: 'pop_BA_Reporting_Clarity_JobFunctionName',
  // Keyword
  Keyword: 'pop_BA_Reporting_Clarity_Keyword',
  // KeywordId
  KeywordId: 'pop_BA_Reporting_Clarity_KeywordID',
  // KeywordLabels
  KeywordLabels: 'pop_BA_Reporting_Clarity_KeywordLabels',
  // KeywordStatus
  KeywordStatus: 'pop_BA_Reporting_Clarity_KeywordStatus',
  // LandingPageExperience
  LandingPageExperience: 'Page_Reporting_Clarity_LandingPageUserExperience',
  // LandingPageTitle
  LandingPageTitle: 'pop_BA_Reporting_Clarity_DSA_LandingPageTitle',
  // Language
  Language: 'pop_BA_Reporting_Clarity_Language',
  // LocalStoreCode
  LocalStoreCode: 'pop_BA_Reporting_Local_Store_Code',
  // LocationId
  LocationId: 'pop_BA_Reporting_Clarity_LocationIdPhysicalLocation',
  // LocationType
  LocationType: 'pop_BA_Reporting_Clarity_LocationType',
  // Logo
  Logo: 'pop_BA_Reporting_Combination_Logo',
  // LongHeadline
  LongHeadline: 'pop_BA_Reporting_Clarity_LongHeadline',
  // LowQualityClicks
  LowQualityClicks: 'pop_BA_Reporting_Clarity_LowQualityClicks',
  // LowQualityClicksPercent
  LowQualityClicksPercent: 'pop_BA_Reporting_Clarity_LowQualityClickRate',
  // LowQualityConversionRate
  LowQualityConversionRate: 'pop_BA_Reporting_Clarity_LowQualityClickConvRate',
  // LowQualityConversions
  LowQualityConversions: 'pop_BA_Reporting_Clarity_LowQualityClickConv',
  LowQualityConversionsQualified: 'pop_BA_Reporting_Clarity_LowQualityClickConv',
  // LowQualityGeneralClicks
  LowQualityGeneralClicks: 'pop_BA_Reporting_Clarity_LowQualityGeneralClicks',
  // LowQualityImpressions
  LowQualityImpressions: 'pop_BA_Reporting_Clarity_LowQualityImp',
  // LowQualityImpressionsPercent
  LowQualityImpressionsPercent: 'pop_BA_Reporting_Clarity_LowQualityImpRate',
  // LowQualitySophisticatedClicks
  LowQualitySophisticatedClicks: 'pop_BA_Reporting_Clarity_LowQualitySophisticatedClicks',
  // Mainline1Bid
  Mainline1Bid: 'pop_BA_CampaignGrids_TopPage',
  // MainlineBid
  MainlineBid: 'pop_BA_CampaignGrids_TopPage',
  // ManualCalls
  ManualCalls: 'pop_BA_CampaignGrids_ManualCalls',
  // MatchedProductsAtAdGroup
  MatchedProductsAtAdGroup: 'pop_BA_BSC_ProductTargeted',
  // MatchedProductsAtCampaign
  MatchedProductsAtCampaign: 'pop_BA_BSC_ProductTargeted',
  // MatchedProductsAtProductGroup
  MatchedProductsAtProductGroup: 'pop_BA_BSC_ProductTargeted',
  // MerchantProductId
  MerchantProductId: 'pop_BA_Reporting_Clarity_MerchantProductID',
  // MetroArea
  MetroArea: 'pop_BA_Reporting_Clarity_MetroPhysical',
  // MissedImpressions
  MissedImpressions: 'pop_BA_Reporting_Clarity_MissedImpressions',
  // MissedImpressionsNoBid
  MissedImpressionsNoBid: 'pop_BA_Reporting_Clarity_MissedImpressionsNoBid',
  // MissedImpressionsNoTax
  MissedImpressionsNoTax: 'pop_BA_Reporting_Clarity_MissedImpressionsNoTax',
  // MissedImpressionsOther
  MissedImpressionsOther: 'pop_BA_Reporting_Clarity_MissedImpressionsOther',
  // MissedImpressionsSpendingCapReached
  MissedImpressionsSpendingCapReached: 'pop_BA_Reporting_Clarity_MissedImpressionsSpendingCapReached',
  // Month
  Month: 'pop_BA_Reporting_Clarity_Month',
  // MonthToDateSpend
  MonthToDateSpend: 'pop_BA_Reporting_Clarity_SpendMonthly',
  // MonthlyBudget
  MonthlyBudget: 'pop_BA_Reporting_Clarity_MonthlyBudget',
  // MostSpecificLocation
  MostSpecificLocation: 'pop_BA_Reporting_Clarity_MostSpecific',
  MPN: 'pop_BA_DimensionGrid_MPN',
  // NegativeKeyword
  NegativeKeyword: 'pop_BA_Reporting_Clarity_NegativeKeyword',
  // NegativeKeyWordList
  NegativeKeywordList: 'pop_BA_CampaignGrids_NegKWInList',
  // NegativeKeywordId
  NegativeKeywordId: 'pop_BA_Reporting_Clarity_NegKeywordID',
  // NegativeKeywordListId
  NegativeKeywordListId: 'pop_BA_Reporting_Clarity_NegKeywordListID',
  // NegativeKeywordMatchType
  NegativeKeywordMatchType: 'pop_BA_Reporting_Clarity_NegativeKeywordMatchID',
  Neighborhood: 'pop_BA_Reporting_Clarity_NeighborhoodLocation',
  // NetAmountDue
  NetAmountDue: 'pop_BA_Reporting_Clarity_NetDue',
  // NetReturnOnAdSpend
  NetReturnOnAdSpend: 'pop_BA_Reporting_Clarity_NetReturnOnAdSpend',
  // NetRevenue
  NetRevenue: 'pop_BA_Reporting_Clarity_NetRevenue',
  // NetRevenueUSD
  NetRevenueUSD: 'pop_BA_Reporting_Clarity_NetRevenueUSD',
  // Network
  Network: 'Page_Reporting_Clarity_Network',
  // NewValue
  NewValue: 'pop_BA_Reporting_Clarity_NewValue',
  // OfferLanguage
  OfferLanguage: 'pop_BA_Reporting_Clarity_ProductOfferLanguage',
  // OldValue
  OldValue: 'pop_BA_Reporting_Clarity_OldValue',
  // Param1
  Param1: 'pop_BA_Reporting_Clarity_Param1',
  // Param2
  Param2: 'pop_BA_Reporting_Clarity_Param2',
  // Param3
  Param3: 'pop_BA_Reporting_Clarity_Param3',
  // PartitionType
  PartitionType: 'pop_BA_Reporting_Clarity_ProductPartitionType',
  // PartnerImpressions
  PartnerImpressions: 'pop_BA_Reporting_Clarity_PartnerImpressions',
  // Path1
  Path1: 'pop_BA_Reporting_Clarity_Path1',
  // Path2
  Path2: 'pop_BA_Reporting_Clarity_Path2',
  // PhoneCalls
  PhoneCalls: 'pop_BA_Reporting_Clarity_PhoneCalls',
  // PhoneImpressions
  PhoneImpressions: 'pop_BA_CampaignGrids_PhoneImpr',
  // PostalCode
  PostalCode: 'pop_BA_Reporting_Clarity_ZipCode',
  // Price
  Price: 'pop_BA_Reporting_Clarity_Price',
  // Pricing Method
  PricingMethod: 'pop_BA_Reporting_Clarity_PricingMethod',
  // ProductBought
  ProductBought: 'pop_BA_Reporting_Clarity_ProductBought',
  ProductBoughtTitle: 'pop_BA_DimensionGrid_ProductBoughtTitle',
  // ProductCategory1
  ProductCategory1: 'pop_BA_Reporting_Clarity_Category',
  // ProductCategory2
  ProductCategory2: 'pop_BA_Reporting_Clarity_Category',
  // ProductCategory3
  ProductCategory3: 'pop_BA_Reporting_Clarity_Category',
  // ProductCategory4
  ProductCategory4: 'pop_BA_Reporting_Clarity_Category',
  // ProductCategory5
  ProductCategory5: 'pop_BA_Reporting_Clarity_Category',
  // ProductGroup
  ProductGroup: 'pop_BA_Reporting_Clarity_ProductGroup',
  // ProductName
  ProductName: 'pop_BA_Reporting_Clarity_ProductName',
  // ProductType1
  ProductType1: 'pop_BA_Reporting_Clarity_ProductType',
  // ProductType2
  ProductType2: 'pop_BA_Reporting_Clarity_ProductType',
  // ProductType3
  ProductType3: 'pop_BA_Reporting_Clarity_ProductType',
  // ProductType4
  ProductType4: 'pop_BA_Reporting_Clarity_ProductType',
  // ProductType5
  ProductType5: 'pop_BA_Reporting_Clarity_ProductType',
  // ProximityTargetLocation
  ProximityTargetLocation: 'pop_BA_Reporting_Clarity_Proximity',
  // Ptr
  Ptr: 'pop_BA_CampaignGrids_PTR',
  // PublisherUrl
  PublisherUrl: 'pop_BA_Reporting_Clarity_WebsitePubURL',
  // QualityImpact
  QualityImpact: 'Page_Reporting_Clarity_QualityImpact',
  // QualityScore
  QualityScore: 'Page_Reporting_Clarity_QualityScore',
  // QuantityBought
  QuantityBought: 'pop_BA_Reporting_Clarity_QuantityBought',
  // Quarter
  Quarter: 'Pop_BA_DimensionGrid_Quarter',
  // QueryIntentCity
  QueryIntentCity: 'pop_BA_Reporting_Clarity_CitySearchFor',
  // QueryIntentCountry
  QueryIntentCountry: 'pop_BA_Reporting_Clarity_CountrySearchFor',
  // QueryIntentCounty
  QueryIntentCounty: 'pop_BA_Reporting_Clarity_CountySearchFor',
  // QueryIntentDMA
  QueryIntentDMA: 'pop_BA_Reporting_Clarity_MetroSearchFor',
  // QueryIntentLocationId
  QueryIntentLocationId: 'pop_BA_Reporting_Clarity_LocationIdSearchFor',
  QueryIntentNeighborhood: 'pop_BA_Reporting_Clarity_NeighborhoodSearchFor',
  // QueryIntentPostalCode
  QueryIntentPostalCode: 'pop_BA_Reporting_Clarity_ZipCodeSearchFor',
  // QueryIntentState
  QueryIntentState: 'pop_BA_Reporting_Clarity_StateSearchFor',
  // Radius
  Radius: 'pop_BA_Reporting_Clarity_Radius',
  // Unique Reach
  Reach: 'pop_BA_Unique_Reach',
  RelativeCTR: 'pop_BA_Reporting_Clarity_RelativeCTR',
  // ReturnOnAdSpend
  ReturnOnAdSpend: 'pop_BA_CampaignGrids_ReturnAdSpend',
  // ReturnOnAdSpendCPS
  ReturnOnAdSpendCPS: 'pop_BA_CampaignGrids_ReturnAdSpend',
  // Revenue
  Revenue: 'pop_BA_CampaignGrids_Revenue',
  // RevenueCPS
  RevenueCPS: 'pop_BA_CampaignGrids_Revenue',
  // RevenuePerAssist
  RevenuePerAssist: 'pop_BA_Reporting_Clarity_RevenueAssist',
  // RevenuePerConversion
  RevenuePerConversion: 'pop_BA_Reporting_Clarity_RevenueConversion',
  // Sales house
  SalesHouse: 'pop_BA_Reporting_Clarity_SalesHouse',
  // SearchQuery
  SearchQuery: 'pop_BA_Reporting_Clarity_SearchTerm',
  // SellerName
  SellerName: 'pop_BA_Reporting_Clarity_SellerName',
  // SoldToCustomerName
  SoldToCustomerName: 'pop_BA_Reporting_Clarity_SoldToName',
  // SoldToCustomerNumber
  SoldToCustomerNumber: 'pop_BA_Reporting_Clarity_SoldToNumber',
  // SoldToCountry
  SoldToCountry: 'pop_BA_Reporting_Clarity_SoldToCountry',
  // Spend
  Spend: 'pop_BA_CampaignGrids_Spend',
  // StarRating
  StarRating: 'pop_BA_Reporting_Clarity_StarRating',
  // StartTime
  StartTime: 'pop_BA_Reporting_Clarity_CallStartTime',
  // State
  State: 'pop_BA_Reporting_Clarity_StatePhysical',
  // Status
  Status: 'pop_BA_Reporting_Clarity_AdGroupStatus',
  // TargetingSetting
  TargetingSetting: 'pop_BA_AudienceTarget',
  // TimePeriod
  TimePeriod: 'pop_BA_Reporting_Clarity_Date',
  // StoreId
  StoreId: 'pop_BA_Reporting_Store_ID',
  // TimePeriod-DayOfWeek
  'TimePeriod-DayOfWeek': 'pop_BA_Reporting_Clarity_DayOfWeek',
  // TimePeriod-HourOfDay
  'TimePeriod-HourOfDay': 'pop_BA_Reporting_Clarity_HourOfDay',
  // Title
  Title: 'pop_BA_Reporting_Clarity_Title',
  // TitlePart1
  TitlePart1: 'pop_BA_Reporting_Clarity_AdTitle1',
  // TitlePart2
  TitlePart2: 'pop_BA_Reporting_Clarity_AdTitle2',
  // TitlePart3
  TitlePart3: 'pop_BA_Reporting_Clarity_AdTitle3',
  // Tool
  Tool: 'pop_BA_Reporting_Clarity_Tool',
  // TopImpressionRatePercent
  TopImpressionRatePercent: 'pop_BA_Reporting_Clarity_TopImpressionRate',
  // TopImpressionShareLostToBudgetPercent
  TopImpressionShareLostToBudgetPercent: 'pop_BA_Reporting_Clarity_TopImpressionLosttoBudget',
  // TopImpressionShareLostToRankPercent
  TopImpressionShareLostToRankPercent: 'pop_BA_Reporting_Clarity_TopImpressionLosttoRank',
  // TopImpressionSharePercent
  TopImpressionSharePercent: 'pop_BA_Reporting_Clarity_TopImpressionShare',
  // TopVsOther
  TopVsOther: 'Page_Reporting_Clarity_TopVsOther',
  // TotalClicks
  TotalClicks: 'pop_BA_Reporting_Clarity_AdExtTotalClicks',
  // TotalClicksOnAdElements
  TotalClicksOnAdElements: 'pop_BA_Reporting_Ad_Element_Total_Clicks',
  // TrackingTemplate
  TrackingTemplate: 'pop_BA_Reporting_Clarity_TrackingTemplate',
  // UserId
  UserId: 'pop_BA_Reporting_Clarity_UserID',
  // WebsiteCoverage
  WebsiteCoverage: 'pop_BA_Reporting_Clarity_DSA_WebsiteCoverage',
  // Week
  Week: 'pop_BA_Reporting_Clarity_Week',
  // WeekStartingMonday
  WeekStartingMonday: 'pop_BA_Reporting_Clarity_WeekStartingMonday',
  // ViewThroughConversions
  ViewThroughConversions: 'pop_BA_Reporting_Clarity_ViewThrough',
  // ViewThroughConversionsRevenue
  ViewThroughRevenue: 'pop_BA_Reporting_Clarity_ViewThroughConvRevenue',
  // ViewThroughConversionsCPA
  ViewThroughCostPerConversion: 'pop_BA_Reporting_Clarity_ViewThroughConvCPA',
  ViewThroughCostPerConversionQualified: 'pop_BA_Reporting_Clarity_ViewThroughConvCPA',
  // ViewThroughConversionsReturnOnAdSpend
  ViewThroughReturnOnAdSpend: 'pop_BA_Reporting_Clarity_ViewThroughConvReturnOnAdSpend',
  // ViewThroughConversionsRate
  ViewThroughConversionRate: 'pop_BA_Reporting_Clarity_ViewThroughConvRate',
  ViewThroughConversionRateQualified: 'pop_BA_Reporting_Clarity_ViewThroughConvRate',
  // Year
  Year: 'pop_BA_Reporting_Clarity_Year',
  /** Video metrics */
  VideoViews: 'pop_BA_VideoAds_VideoViews',
  ViewThroughRate: 'pop_BA_VideoAds_ViewThroughRate',
  AverageCPV: 'pop_BA_VideoAds_AverageCPV',
  TotalWatchTimeInMS: 'Page_CampaignGrids_TotalWatchTimeInMS',
  AverageWatchTimePerImpression: 'pop_BA_VideoAds_AverageWatchTimePerImpression',
  AverageWatchTimePerVideoView: 'pop_BA_VideoAds_AverageWatchTimePerVideoView',
  VideoViewsAt25Percent: 'pop_BA_VideoAds_VideoViewsAt25Percent',
  VideoViewsAt50Percent: 'pop_BA_VideoAds_VideoViewsAt50Percent',
  VideoViewsAt75Percent: 'pop_BA_VideoAds_VideoViewsAt75Percent',
  CompletedVideoViews: 'pop_BA_VideoAds_CompletedVideoViews',
  VideoCompletionRate: 'Page_CampaignGrids_VideoCompletionRate',

  ChangeInAdvertiserReportedRevenuePct: 'pop_BA_Reporting_Clarity_AllConvChangeRevenue', // '% Change in All conv. revenue'
  ChangeInAllConvRatePct: 'pop_BA_Reporting_Clarity_AllConvChangeRate', // '% Change in All conv. rate'
  ChangeInConversionCreditPct: '% Change in All conv.', // pop_BA_Reporting_Clarity_AllConvChange
  ChangeInCPAPct: 'pop_BA_Reporting_Clarity_AllConvChangeCpa', // '% Change in CPA'
  ChangeInFullViewAdvertiserReportedRevenuePct: 'pop_BA_Reporting_Clarity_AllConv_ViewThroughConvRevenue', // '% Change in View-through conv. revenue'
  ChangeInFullViewThroughConversionPct: 'pop_BA_Reporting_Clarity_AllConvChange_ViewThrough', // '% Change in View-through conv.'
  ChangeInROASPct: 'pop_BA_Reporting_Clarity_AllConvChangAdSpend', // '% Change in Return on ad spend'
  ChangeInViewThroughRatePct: 'pop_BA_Reporting_Clarity_AllConvChangeRate', // '% Change in View-through conv. rate'
  ChangeInVTCCPAPct: 'pop_BA_Reporting_Clarity_AllConvChange_ViewThroughCpa', // '% Change in View-through conv. CPA'
  ChangeInVTCROASPct: 'pop_BA_Reporting_Clarity_AllConvChange_ViewT_ROAS', // '% Change in View-through conv. return on ad spend'
  DDAAllConvRate: 'pop_BA_Reporting_Clarity_AllConvRateDda', // 'All conv. rate (DDA)'
  DDACPA: 'pop_BA_Reporting_Clarity_AllConvCPA_Dda', // 'CPA (DDA)'
  DDAFullAdvertiserReportedRevenue: 'pop_BA_Reporting_Clarity_AllConvRevenueDda', // 'All conv. revenue (DDA)'
  DDAFullConversionCredit: 'pop_BA_Reporting_Clarity_AllConvDda', // 'All conv. (DDA)',
  DDAFullViewAdvertiserReportedRevenue: 'pop_BA_Reporting_Clarity_ViewThroughRevenueDda', // 'View-through conv. revenue (DDA)'
  DDAFullViewThroughConversion: 'pop_BA_Reporting_Clarity_ViewThrough_Dda', // 'View-through conv. (DDA)'
  DDAROAS: 'pop_BA_Reporting_Clarity_AllConvROAS_Dda', // 'Return on ad spend (DDA)'
  DDAViewThroughRate: 'pop_BA_Reporting_Clarity_ViewThroughConvRateDda', // 'View-through conv. rate (DDA)'
  DDAVTCCPA: 'pop_BA_Reporting_Clarity_ViewThroughConvCpa_Dda', // 'View-through conv. CPA (DDA)'
  DDAVTCROAS: 'pop_BA_Reporting_Clarity_ViewTConv_ROAS_Dda', // 'View through conv. return on ad spend (DDA)'
  LCAAllConvRate: 'pop_BA_Reporting_Clarity_AllConvRateLca', // 'All conv. rate (LCA)'
  LCACPA: 'pop_BA_Reporting_Clarity_AllConvCPA_Lca', // 'CPA (LCA)'
  LCAFullAdvertiserReportedRevenue: 'pop_BA_Reporting_Clarity_AllConvRevenueLca', // 'All conv. revenue (LCA)'
  LCAFullConversionCredit: 'pop_BA_Reporting_Clarity_AllConvLca ', // 'All conv. (LCA)',
  LCAFullViewAdvertiserReportedRevenue: 'pop_BA_Reporting_Clarity_ViewThroughRevenueLca', // 'View-through conv. revenue (LCA)'
  LCAFullViewThroughConversion: 'pop_BA_Reporting_Clarity_ViewThrough_Lca', // 'View-through conv. (LCA)'
  LCAROAS: 'pop_BA_Reporting_Clarity_AllConvROAS_LCA', // 'Return on ad spend (LCA)'
  LCAViewThroughRate: 'pop_BA_Reporting_Clarity_ViewThroughConvRateLca', // 'View-through conv. rate (LCA)'
  LCAVTCCPA: 'pop_BA_Reporting_Clarity_ViewThroughConvCpa_Lca', // 'View-through conv. CPA (LCA)'
  LCAVTCROAS: 'pop_BA_Reporting_Clarity_ViewTConv_ROAS_Lca', // 'View-through conv. return on ad spend (LCA)'
  IsMainConversionGoal: 'pop_BA_Reporting_Clarity_IncludedInConv', // 'Include in converions'
  Installs: 'pop_BA_StoreAds_Install',
  CostPerInstall: 'pop_BA_StoreAds_CostPerInstall',
  RevenuePerInstall: 'pop_BA_StoreAds_RevenuePerInstall',
  Sales: 'pop_BA_StoreAds_Sales',
  CostPerSale: 'pop_BA_StoreAds_CostPerSale',
  RevenuePerSale: 'pop_BA_StoreAds_RevenuePerSale',

  AssetGroupId: 'pop_BA_Reporting_AssetGroupID',
  AssetGroupName: 'pop_BA_Reporting_AssetGroup',
  AssetGroupStatus: 'pop_BA_Reporting_AssetGroup_Status',

  // App ads camapign reporting metrics
  Downloads: 'pop_BA_AppAds_Downloads',
  PostClickDownloadRate: 'pop_BA_AppAds_DownloadRate',
  CostPerDownload: 'pop_BA_AppAds_CostPerDownload',
  AppInstalls: 'pop_BA_AppAds_Installs',
  PostClickInstallRate: 'pop_BA_AppAds_InstallRate',
  CPI: 'pop_BA_AppAds_CostPerInstall',
  Purchases: 'pop_BA_AppAds_InAppPurchase',
  PostInstallPurchaseRate: 'pop_BA_AppAds_PostInstallPurchase',
  CPP: 'pop_BA_AppAds_CostPerInAppPurchase',
  Subscriptions: 'pop_BA_AppAds_InAppSubscription',
  PostInstallSubscriptionRate: 'pop_BA_AppAds_PostInstallSubscription',
  CPS: 'pop_BA_AppAds_CostPerInAppSubscription',
  RevenuePerDownload: 'pop_BA_AppAds_RevenuePerDownload',
  RevenuePerAppInstall: 'pop_BA_AppAds_RevenuePerInstall',

  // Insertion order report metrics
  ChangeAmount: 'pop_BA_Accounts_IO_IOReportsAmount',
  ChangeType: 'pop_BA_Accounts_IO_IOReportsChangeType',
  RemainingIOBudget: 'pop_BA_AccountsGrid_BudgetRem',
  InsertionOrderDetails: 'pop_BA_Accounts_IO_IOReportsDetails',
  BillingDocumentNumber: 'pop_BA_Accounts_IO_IOReportsBillingDoc',

  // Asset reporting metrics
  AssetId: 'pop_BA_AssetID',
  AssetContent: 'pop_BA_AssetContent',
  AssetType: 'pop_BA_Asset_type',
  AssetSource: 'pop_BA_AssetSource',

  // Search term insight reporting metrics
  SearchCategory: 'pop_BA_SearchCategory',
  SearchVolume: 'pop_BA_SearchVolume',

  /** Marketplace insights metrics */
  L1Vertical: 'Pop_BA_Reporting_L1Vertical',
  L2Vertical: 'Pop_BA_Reporting_L2Vertical',
  L3Vertical: 'Pop_BA_Reporting_L3Vertical',
  SearchesIndexed: 'pop_BA_Reporting_Searches',
  ClicksIndexed: 'pop_BA_AssetLibraryPerformance_Clicks',
  WoWSearches: 'Pop_BA_Reporting_WoWSearches',
  WoWClicks: 'Pop_BA_Reporting_WoWClicks',
  MoMSearches: 'Pop_BA_Reporting_MoMSearches',
  MoMClicks: 'Pop_BA_Reporting_MoMClicks',
  YoYLast1WeekSearches: 'Pop_BA_Reporting_YoYSearches',
  YoYLast1WeekClicks: 'Pop_BA_Reporting_YoYClicks',
  YoYLast4WeeksSearches: 'Pop_BA_Reporting_YoYLFWSearches',
  YoYLast4WeeksClicks: 'Pop_BA_Reporting_YoYLFWClicks',
  SearchesPeekWeek: 'Pop_BA_Reporting_PeakWeeklySearches',
  ClicksPeekWeek: 'Pop_BA_Reporting_PeakWeeklyClicks',
  MarketplaceClickCoverage: 'Pop_BA_Reporting_ClicksharePercentage',
  ProportionOfSpend: 'Pop_BA_Reporting_ProportionSpend',

  // New Customer Acqusition Goal
  NewCustomerConversions: 'pop_BA_PMAX_NewCustomerConv',
  NewCustomerRevenue: 'pop_BA_PMAX_NewCustomerConvValue',
  NewCustomerConversionRate: 'pop_BA_PMAX_NewCustomerConvRate',
  NewCustomerReturnOnAdSpend: 'pop_BA_PMAX_NewCustomerConROAS',
  NewCustomerCPA: 'pop_BA_PMAX_NewCustomerConCPA',
};

export const helpLinkIdsByReportType = {
  GenrePerformanceReport: {
    CampaignName: 'pop_BA_VideoAds_Reporting_CampaignAdGroup',
    CampaignId: 'pop_BA_VideoAds_Reporting_CampaignAdGroup',
    AdGroupName: 'pop_BA_VideoAds_Reporting_CampaignAdGroup',
    AdGroupId: 'pop_BA_VideoAds_Reporting_CampaignAdGroup',
    Genre: 'pop_BA_VideoAds_Reporting_Genre',
    Impressions: 'pop_BA_VideoAds_Reporting_Impressions',
    VideoViewsAt25Percent: 'pop_BA_Columns_VideoViews25',
    VideoViewsAt50Percent: 'pop_BA_Columns_VideoViews50',
    VideoViewsAt75Percent: 'pop_BA_Columns_VideoViews75',
    CompletedVideoViews: 'pop_BA_CampaignGrids_CompletedVideoViews',
    AverageCPM: 'pop_BA_VideoAds_Reporting_CPM',
    AverageCPV: 'pop_BA_VideoAds_Reporting_CPCV',
    Spend: 'pop_BA_VideoAds_Reporting_TotalSpend',
    VideoCompletionRate: 'pop_BA_CampaignGrids_VideoCompletionRate',
  },
};
